export const COMPONENT_KEY = 'shared-component-pid-not-found';
